export default "__VITE_ASSET__DJg7hy_z__"